import { AppLogo, type AppLogoName } from '@parcel/ui/app-logo';
import { Fragment } from 'react';

const HERO_LOGOS: readonly { name: AppLogoName; featured?: boolean }[] = [
  { name: 'claude' },
  { name: 'openai' },
  { name: 'mcp', featured: true },
  { name: 'codex' },
  { name: 'cursor' },
];

function McpHeroBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <svg
        className="absolute inset-0 h-full w-full"
        viewBox="0 0 800 180"
        preserveAspectRatio="xMidYMid slice"
        aria-hidden="true"
      >
        <defs>
          <radialGradient id="mcp-hero-glow" cx="50%" cy="45%" r="55%">
            <stop offset="0%" stopColor="#fff" stopOpacity="0.1" />
            <stop offset="70%" stopColor="#fff" stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="800" height="180" fill="url(#mcp-hero-glow)" />
        <g fill="#fff" opacity="0.06">
          <rect width="300" height="20" x="-60" y="8" rx="10" transform="rotate(-28 90 18)" />
          <rect width="380" height="24" x="430" y="-16" rx="12" transform="rotate(-28 620 0)" />
          <rect width="260" height="16" x="40" y="148" rx="8" transform="rotate(-28 170 156)" />
          <rect width="320" height="18" x="490" y="128" rx="9" transform="rotate(-28 650 137)" />
        </g>
        <g stroke="#fff" strokeDasharray="3 12" strokeOpacity="0.1" strokeWidth="1">
          <line x1="24" x2="776" y1="42" y2="42" />
          <line x1="64" x2="736" y1="138" y2="138" />
        </g>
      </svg>
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.08]">
        <AppLogo name="mcp" size={168} className="text-white" />
      </div>
    </div>
  );
}

/**
 * Dark MCP-cover-style strip: watermarked protocol mark with the supported
 * client logos in a connected row. Decorative — keep it out of the a11y tree.
 */
export function McpClientHero() {
  return (
    <div
      data-testid="mcp-client-hero"
      aria-hidden="true"
      className="relative mb-8 overflow-hidden rounded-xl border border-white/10 bg-[#161618]"
    >
      <McpHeroBackdrop />
      <div className="relative flex items-center justify-center px-4 py-9 sm:px-10 sm:py-11">
        {HERO_LOGOS.map((logo, index) => (
          <Fragment key={logo.name}>
            {index > 0 ? (
              <span className="mx-3 h-px w-6 shrink-0 bg-white/20 sm:mx-5 sm:w-12" />
            ) : null}
            <AppLogo name={logo.name} size={logo.featured ? 40 : 28} className="text-white" />
          </Fragment>
        ))}
      </div>
    </div>
  );
}
